const usDollarFormatter = new Intl.NumberFormat("en-US", {
  currency: "USD",
  maximumFractionDigits: 0,
  style: "currency",
});

export const formatDollars = (cents: number) =>
  usDollarFormatter.format(cents / 100);

export const QUICK_OPTION_DOLLARS = [25, 50, 100, 150, 200];
